/**
 * External dependencies
 */
import $ from 'jquery';

/**
 *
 * @param el
 */
function addRemoveActive ( el ) {
    $( '.timeline .date' ).removeClass( 'active' );
    el.addClass( 'active' );

    var inactive = $( '.image-wrapper > .inactive' );
    var active = $( '.image-wrapper > .active' );


    inactive.css( 'background-image','url(' + el.data( "background-image" ) + ')' );
    active.fadeOut( function(){
        inactive.fadeIn();
        active.removeClass( "active" ).addClass( "inactive" );
        inactive.removeClass( "inactive" ).addClass( "active" );

        $( '.milestones .content-container .content' ).removeClass( 'active' );
        $( '.milestones .content-container .content' ).eq( el.index() ).addClass( 'active' );
    } );
}

$( document ).ready( function() {
    $( '#main-image-1' ).css( 'background-image','url(' + $( ".timeline .date" ).first().data( "background-image" ) + ')' );

	$( '.timeline .date' ).on( 'mouseenter', function() {
		addRemoveActive( $( this ) );
	} );
    $( '.timeline .date' ).on( 'click', function() {
        addRemoveActive( $( this ) );
    } );
} );